import styled from "styled-components";
import { CostParagraph } from "components/atoms/CostParagraph/CostParagraph";
import { StyleSheet } from "@react-pdf/renderer";
export const ChartWrapper = styled.div`
  padding-top: 20px;
  padding-bottom: 40px;
  display: none;
  @media (min-width: 820px) {
    display: block;
  }
`;
export const SummaryFormWrapper = styled.div`
  background: ${({ theme }) => theme.colors.grey1};
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: center;
  max-width: 420px;
  margin: 0 auto;
  form {
    width: 100%;
    input[type="email"] {
      width: 100%;
      border: 1px solid ${({ theme }) => theme.colors.grey1};
      background: ${({ theme }) => theme.colors.white};
      padding: 10px;
      &:placeholder {
        color: ${({ theme }) => theme.colors.grey1};
      }
    }
  }
  .checkbox-wrapper {
    margin-top: 10px;
    margin-bottom: 40px;
    input[type="checkbox"] {
      vertical-align: middle;
      margin-left: 0;
    }
    label {
      color: ${({ theme }) => theme.colors.dark};
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      span {
        a {
          color: ${({ theme }) => theme.colors.red};
        }
      }
    }
  }
  .error {
    color: ${({ theme }) => theme.colors.red} !important;
    margin-top: 1px;
    font-size: ${({ theme }) => theme.fontSize.s};
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    width: 100%;
    margin: 0;
  }
  .green {
    color: ${({ theme }) => theme.colors.green};
  }
  .sent {
    margin-top: 1px;
    font-size: ${({ theme }) => theme.fontSize.m};
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    width: 100%;
    margin: 0;
    text-align: center;
    margin-top: 10px;
  }
`;

export const SummaryCostParagraph = styled(CostParagraph)`
  margin-top: 0;
  margin-bottom: 40px;
`;

export const Paragraph = styled.p`
  font-family: Inter;
  color: ${({ theme }) => theme.colors.dark};
  font-size: ${({ theme }) => theme.fontSize.m};
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  margin-top: 0;
  margin-bottom: 0;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  @media (min-width: 414px) {
    gap: 40px;
  }
  @media (min-width: 768px) {
    padding-left: 10px;
    padding-right: 10px;
  }
  button {
    height: 51px;
    &:nth-child(1) {
      background-color: ${({ theme }) => theme.colors.white} !important;
    }
    &:nth-child(2) {
      @media (min-width: 768px) {
        width: 155px !important;
      }
    }
  }
`;

export const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto",
    padding: "0.5in",
    width: "100%",
  },
  title: {
    fontSize: 20,
    fontWeight: "bold",
    wordWrap: "break-word",
    textAlign: "center",
    marginBottom: 40,
    marginTop: 40,
  },
  subtitle: {
    fontSize: 16,
    marginBottom: 2,
    fontWeight: "bold",
    wordWrap: "break-word",
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    marginBottom: 20,
  },
  tableCell: {
    padding: 8,
    fontSize: 10,
    borderStyle: "solid",
    borderBottom: 1,
    wordWrap: "break-word",
    width: "100%",
  },
  headerCell: {
    padding: 5,
    fontSize: 14,
    backgroundColor: "#BE1622", // Header cell background color
    color: "white", // Header cell text color
    fontWeight: "bold",
    wordWrap: "break-word",
  },
  summaryCell: {
    width: "100%",
    padding: 5,
    fontSize: 14,
    fontWeight: "bold",
    wordWrap: "break-word",
  },
  summaryCellRoi: {
    width: "100%",
    padding: 5,
    textAlign: "center",
    fontSize: 20,
    fontWeight: "bold",
    wordWrap: "break-word",
  },
  logowrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  image: {
    width: 120,
    marginBottom: 15,
  },
  cta: {
    width: "100%",
    marginBottom: 15,
    marginTop: 10,
  },
  contactinfo: {
    fontSize: 10,
  },
  datatxt: {
    fontSize: 10,
    marginBottom: 10,
  },
  chart: {
    marginTop: 10,
  },
  mail: {
    color: "#BE1622",
  },
  pagenumber: {
    position: "absolute",
    bottom: "0.5in",
    right: "0.5in",
    fontSize: 10,
  },
  thanku: {
    width: "100%",
    marginBottom: 5,
    marginTop: 5,
  },
});
